import appConfig from 'src/config/app.config.json'

const getConfigForEnv = (env: 'dev' | 'live' | 'prod' | 'local') => {
  const getConfig = (hostname: string) =>
    appConfig.find(obj => obj.hostname === hostname)
  if (env === 'dev') return getConfig('all-dev')
  if (env === 'live') return getConfig('all-live')
  if (env === 'prod') return getConfig('all-com')
  return getConfig('localhost')
}

export const getAppConfig = (): typeof window.APP_CONFIG => {
  const hostname = window.location.hostname.toLowerCase()
  if (hostname.includes('.com')) {
    return getConfigForEnv('prod') as unknown as typeof window.APP_CONFIG
  }
  if (hostname.includes('.live')) {
    return getConfigForEnv('live') as unknown as typeof window.APP_CONFIG
  }
  if (hostname.includes('.dev')) {
    return getConfigForEnv('dev') as unknown as typeof window.APP_CONFIG
  }
  return getConfigForEnv('local') as unknown as typeof window.APP_CONFIG
}

export const getProviderDomainUrlForContext = (): string =>
  getAppConfig()?.REACT_APP_CAREPOINT_URL ||
  getConfigForEnv('dev')?.REACT_APP_CAREPOINT_URL ||
  ''

export const getLocationServiceUrl = (): string =>
  getAppConfig()?.REACT_APP_LOCATION_SERVICE_URL || ''

export const getProviderPortalUrlForContext = (): string =>
  getAppConfig()?.REACT_APP_PROVIDER_PORTAL_API_URL ||
  getConfigForEnv('dev')?.REACT_APP_PROVIDER_PORTAL_API_URL ||
  ''
